import React from 'react';
import './ScoreBoard.css';

const ScoreBoard = ({ score, highScore }) => {
  return (
    <div className="score-board">
      <div className="current-score">
        <span className="score-label">점수:</span>
        <span className="score-value">{score}</span>
      </div>
      <div className="high-score">
        <span className="score-label">최고 점수:</span>
        <span className="score-value">{highScore}</span>
      </div>
    </div>
  );
};

export default ScoreBoard;
